export default __webpack_public_path__ + "static/ccore-d2a193fdef55b747ebc01f06b10cbe02.png";